import { SET_MAP_MISSIONS, SET_MAP_SQUARES, UPDATE_MAP_SQUARES } from '~/store/map/mutation-types';

export default {
  [SET_MAP_SQUARES](state, payload) {
    state.squares.push(payload);
  },
  [UPDATE_MAP_SQUARES](state, missions) {
    /*
    missions.forEach((mission) => {
      const square = state.squares.find(())
    });
    */
    state.squares = missions;
  },
  [SET_MAP_MISSIONS](state, payload) {
    state.missions = payload;
  },
};
